<!-- filepath: src/pages/ai-agent/components/AiAgentGridItem.vue -->
<template>
  <el-card :body-style="{ padding: '16px' }" shadow="hover">
    <div class="flex items-start justify-between pb-2">
      <div class="flex items-start gap-3">
        <el-avatar
          :src="item.avatar_url || '/placeholder.svg'"
          size="medium"
          class="flex-none"
        >
          <i :class="getTypeIcon(item?.config?.type)" />
        </el-avatar>
        <div>
          <div
            class="font-bold whitespace-nowrap overflow-hidden text-ellipsis"
          >
            {{ item.name }}
          </div>
          <div
            class="text-gray-500 text-xs overflow-hidden"
            style="
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              line-clamp: 2;
              height: 2.8em;
            "
          >
            <i class="el-icon-info mr-1" />
            {{ item.description }}
          </div>
        </div>
      </div>
      <el-dropdown @command="handleMenuCommand" trigger="click">
        <span class="el-dropdown-link cursor-pointer">
          <i class="el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="chat">
            <i class="el-icon-chat-line-square mr-2" />
            Chat withAgent
          </el-dropdown-item>
          <el-dropdown-item command="configure">
            <i class="el-icon-edit mr-2" />
            Configure Agent
          </el-dropdown-item>
          <el-dropdown-item command="knowledge">
            <i class="el-icon-notebook-2 mr-2" />
            Knowledge Base
          </el-dropdown-item>
          <!-- <el-dropdown-item command="prompt">
            <i class="el-icon-s-opportunity mr-2" />
            Prompt 
            Engineering
          </el-dropdown-item>-->
          <!-- <el-dropdown-item command="collab"><i class="el-icon-share mr-2" />Agent Collaboration</el-dropdown-item> -->
          <!-- <el-dropdown-item command="access"><i class="fa fa-shield mr-2" />Permissions</el-dropdown-item> -->
          <!-- <el-dropdown-item command="access"><i class="el-icon-lock mr-2" />Access Control</el-dropdown-item> -->
          <el-dropdown-item command="share">
            <i class="el-icon-share mr-2" />Share Agent
          </el-dropdown-item>
          <el-dropdown-item divided command="delete" style="color: red">
            <i class="el-icon-delete mr-2" />Delete Agent
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="space-y-3">
      <div class="flex flex-row items-center justify-between">
        <div class="flex items-center gap-2">
          <i :class="getStatusIcon('active')" />
          <span class="text-sm capitalize">{{ item.personality }}</span>
        </div>
        <el-tag effect="plain" hit type="info" size="mini">
          {{ item?.config?.type ?? "none" }}
        </el-tag>
      </div>
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <i class="el-icon-connection text-gray-400" />
          <span class="text-sm">{{ item.base_model }}</span>
        </div>
        <span class="text-sm font-medium">&nbsp;</span>
      </div>
      <div>
        <div class="flex items-center justify-between text-sm">
          <span class="text-gray-400">Knowledge Base</span>
          <span>{{ docs.length }} files</span>
        </div>
        <!-- <el-progress :percentage="100" :stroke-width="8" /> -->
      </div>
      <!-- <div>
        <div class="flex items-center justify-between text-sm">
          <span class="text-gray-400">Collaborations</span>
          <span>{{ item.collaborations ? item.collaborations.length : 0 }} agents</span>
        </div>
        <el-progress :percentage="(item.collaborations ? item.collaborations.length : 0) * 30" :stroke-width="8" />
      </div> -->
      <!-- <div class="flex items-center justify-between text-sm">
        <div class="flex items-center gap-1">
          <i class="el-icon-message text-gray-400" />
          <span>{{ item.conversation_history_limit }} conversations</span>
        </div>
        <div class="flex items-center gap-1">
          <i class="el-icon-time text-gray-400" />
          <span>{{ item.conversation_history_limit }} days</span>
        </div>
      </div> -->
    </div>
    <div class="flex justify-between mt-4">
      <el-button size="mini" @click="handleMenuCommand('chat')">
        <i class="el-icon-message mr-1" />Chat
      </el-button>
      <el-button size="mini" @click="handleMenuCommand('configure')">
        <i class="el-icon-setting mr-1" />Configure
      </el-button>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "AiAgentGridItem",
  emits: ["command"],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    docs: {
      get() {
        // 找到 get_agent_knowledge function 并返回 rag.docs
        const fn = this.item?.functions?.find(
          (f) => f.function_id === "get_agent_knowledge"
        );
        return fn && fn.rag ? fn.rag.docs : [];
      },
      set(value) {
        const fn = this.item?.functions?.find(
          (f) => f.function_id === "get_agent_knowledge"
        );
        if (fn && fn.rag) {
          fn.rag.docs = value;
        }
      },
    },
  },
  methods: {
    getTypeIcon(type) {
      // 返回 Element UI icon class 或自定义 SVG
      switch (type) {
        case "support":
          return "el-icon-user";
        case "analytics":
          return "el-icon-data-analysis";
        case "maintenance":
          return "el-icon-setting";
        case "optimization":
          return "el-icon-s-operation";
        case "security":
          return "el-icon-lock";
        case "none":
          return "el-icon-question";
        default:
          return "el-icon-user";
      }
    },
    getStatusIcon(status) {
      // 返回 Element UI icon class
      switch (status) {
        case "active":
          return "el-icon-success";
        case "inactive":
          return "el-icon-error";
        case "training":
          return "el-icon-loading";
        default:
          return "el-icon-info";
      }
    },
    handleMenuCommand(cmd) {
      this.$emit("command", { command: cmd, item: this.item });
    },
  },
};
</script>
